import React from "react";
import styled from "styled-components";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./style/flexboxgrid.min.css";
import './style/index.css';
import './style/spaceCreation.css';

// Sections
import TopNavbar from "./components/Nav/RedirectsTopNavbar";
import SpaceCreationWizard from "./components/Sections/creationWizard/SpaceCreationWizard";
import Footer from "./components/Sections/FooterRedirects"

export default function Landing() {
  return (
    <div id="wizardRoot">
      <TopNavbar />
      <Wrapper id="home" className="wizardContainer container flexSpaceCenter">
        <SpaceCreationWizard />
      </Wrapper>
      <Footer />
    </div>
  );
}



const Wrapper = styled.section`
  padding-top: 80px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: 820px;
  
  @media (max-width: 1200px) {
    width: 95%;
  }
  
  @media (max-width: 960px) {
    flex-direction: column;
    width: 100%;
    padding: 20px 10px;
    padding-top: 100px;
  }
  
  @media (max-width: 480px) {
    padding: 10px 5px;
    padding-top: 100px;
  }
`;
